// CardGuidance.translations.ts
export default {
  grade9: {
    id: 'product_jp_product_condition_switcher_grade_9',
    defaultMessage: 'Premium is',
  },
  grade10: {
    id: 'product_jp_product_condition_switcher_grade_10',
    defaultMessage: 'A grade (Excellent) is',
  },
  grade11: {
    id: 'product_jp_product_condition_switcher_grade_11',
    defaultMessage: 'B grade (Good) is',
  },
  grade12: {
    id: 'product_jp_product_condition_switcher_grade_12',
    defaultMessage: 'C grade (Fair) is',
  },
  screenDescription9: {
    id: 'product_jp_product_condition_screen_carousel_premium_content',
    defaultMessage: 'No scratch.',
  },
  screenDescription9New: {
    id: 'product_jp_product_condition_screen_carousel_premium_content_new',
    defaultMessage: 'No scratch',
  },
  screenDescription10: {
    id: 'product_jp_product_condition_screen_carousel_grade_a_content',
    defaultMessage: 'No scratch.',
  },
  screenDescription10New: {
    id: 'product_jp_product_condition_screen_carousel_grade_a_content_new',
    defaultMessage: 'No scratch',
  },
  screenDescription11: {
    id: 'product_jp_product_condition_screen_carousel_grade_b_content',
    defaultMessage: 'No scratch.',
  },
  screenDescription11New: {
    id: 'product_jp_product_condition_screen_carousel_grade_b_content_new',
    defaultMessage: 'No scratch',
  },
  screenDescription12: {
    id: 'product_jp_product_condition_screen_carousel_grade_c_content',
    defaultMessage:
      'There are some light scratches that are not visible when the power is turned on.',
  },
  screenDescription12New: {
    id: 'product_jp_product_condition_screen_carousel_grade_c_content_new',
    defaultMessage: 'Minor scratches',
  },
  bodyDescription9: {
    id: 'product_jp_product_condition_body_carousel_premium_content',
    defaultMessage: 'Best quality product available on Back Market.',
  },
  bodyDescription9New: {
    id: 'product_jp_product_condition_body_carousel_premium_content_new',
    defaultMessage: 'Almost no signs of use.',
  },
  bodyDescription10: {
    id: 'product_jp_product_condition_body_carousel_grade_a_content',
    defaultMessage:
      'There may be slight scratches that are barely visible from a distance of 20cm.',
  },
  bodyDescription10New: {
    id: 'product_jp_product_condition_body_switcher_grade_a_content',
    defaultMessage: 'Almost no scratches or dents.',
  },
  bodyDescription11: {
    id: 'product_jp_product_condition_body_carousel_grade_b_content',
    defaultMessage:
      'There are minor scratches that are only visible from a distance of 50cm.',
  },
  bodyDescription11New: {
    id: 'product_jp_product_condition_body_switcher_grade_b_content',
    defaultMessage: 'Minor scratches or dents.',
  },
  bodyDescription12: {
    id: 'product_jp_product_condition_body_carousel_grade_c_content',
    defaultMessage:
      "There are scratches and dents visible from a distance of 50cm, but they don't affect the functionality.",
  },
  bodyDescription12New: {
    id: 'product_jp_product_condition_body_switcher_grade_c_content',
    defaultMessage: 'Visible scratches and dents.',
  },
  body: {
    id: 'product_jp_product_condition_switcher_body',
    defaultMessage: 'Body',
  },
  screen: {
    id: 'product_jp_product_condition_switcher_screen',
    defaultMessage: 'Screen',
  },
  battery: {
    id: 'product_jp_product_condition_switcher_battery',
    defaultMessage: 'Battery',
  },
  batteryDescription9: {
    id: 'product_jp_product_condition_battery_carousel_premium_content',
    defaultMessage: '90~100% battery capacity guarantee.',
  },
  batteryDescription9New: {
    id: 'product_jp_product_condition_battery_carousel_premium_content_new',
    defaultMessage: 'Over 90% guaranteed.',
  },
  batteryDescription10: {
    id: 'product_jp_product_condition_battery_carousel_grade_a_content',
    defaultMessage: '80~100% battery capacity guarantee.',
  },
  batteryDescription11: {
    id: 'product_jp_product_condition_battery_carousel_grade_b_content',
    defaultMessage: '80~100% battery capacity guarantee.',
  },
  batteryDescription12: {
    id: 'product_jp_product_condition_battery_carousel_grade_c_content',
    defaultMessage: '80~100% battery capacity guarantee.',
  },
}
